import Input from '@/components/ui/Input';

export default function SectionTravaux({ data, onChange }) {
  const val = (field) => field.split('.').reduce((obj, key) => obj?.[key], data) ?? '';
  const handleChange = (field) => (e) => onChange(field, e.target.value);
  const handleCheck = (field) => (e) => onChange(field, e.target.checked);

  const sansObjet = data?.travaux?.sans_objet ?? true;

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <label className="flex items-center gap-2 text-sm text-slate-700">
          <input
            type="checkbox"
            checked={sansObjet}
            onChange={handleCheck('travaux.sans_objet')}
            className="rounded border-slate-300"
          />
          Sans objet
        </label>
        {!sansObjet && (
          <>
            <Input
              label="Travaux réalisés"
              type="textarea"
              value={val('travaux.travaux_realises')}
              onChange={handleChange('travaux.travaux_realises')}
              placeholder="Description des travaux récents..."
            />
            <Input
              label="Travaux prévisionnels"
              type="textarea"
              value={val('travaux.travaux_previsionnels')}
              onChange={handleChange('travaux.travaux_previsionnels')}
              placeholder="Travaux à prévoir, estimations..."
            />
            <Input
              label="Travaux de mise aux normes TTC (€)"
              name="travaux.normes_ttc_euros"
              type="number"
              value={val('travaux.normes_ttc_euros')}
              onChange={handleChange('travaux.normes_ttc_euros')}
            />
            <Input
              label="Travaux financés TTC (€)"
              name="travaux.finances_ttc_euros"
              type="number"
              value={val('travaux.finances_ttc_euros')}
              onChange={handleChange('travaux.finances_ttc_euros')}
            />
            <Input
              label="Financés par"
              name="travaux.finances_par"
              value={val('travaux.finances_par')}
              onChange={handleChange('travaux.finances_par')}
              placeholder="ex: Propriétaire, Copropriété"
            />
            <Input
              label="Travaux de confort TTC (€)"
              name="travaux.confort_ttc_euros"
              type="number"
              value={val('travaux.confort_ttc_euros')}
              onChange={handleChange('travaux.confort_ttc_euros')}
            />
          </>
        )}
      </div>
    </div>
  );
}
